import { isMemberImportReconciliationResponse, isMemberImportResolutionResponse } from '@urbanik/api-contracts';
export class MemberImportReconciliationApiError extends Error {
    kind;
    constructor(kind, message) {
        super(message);
        this.kind = kind;
        this.name = 'MemberImportReconciliationApiError';
    }
}
const endpoint = (baseUrl) => `${baseUrl.replace(/\/$/, '')}/identity/member-import/reconciliation`;
async function payload(response) {
    try {
        return (await response.json());
    }
    catch {
        throw new MemberImportReconciliationApiError('invalid', 'Respuesta inválida.');
    }
}
const statusError = (response) => {
    if (response.status === 401)
        throw new MemberImportReconciliationApiError('unauthorized', 'Debes iniciar sesión.');
    if (response.status === 403)
        throw new MemberImportReconciliationApiError('forbidden', 'No tienes permiso para conciliar.');
};
export async function getMemberImportReconciliation(baseUrl, signal) {
    let response;
    try {
        response = await fetch(endpoint(baseUrl), { headers: { Accept: 'application/json' }, credentials: 'include', signal: signal ?? null });
    }
    catch {
        throw new MemberImportReconciliationApiError('unavailable', 'No pudimos consultar la conciliación.');
    }
    statusError(response);
    const body = await payload(response);
    if (!response.ok || !isMemberImportReconciliationResponse(body))
        throw new MemberImportReconciliationApiError('invalid', 'No se pudo interpretar la conciliación.');
    return body;
}
export async function resolveMemberImportException(baseUrl, rowId, action, reason, nationalId, existingMemberId) {
    let response;
    try {
        response = await fetch(`${endpoint(baseUrl)}/${rowId}`, {
            method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, credentials: 'include',
            body: JSON.stringify({ action, reason, confirm: true, ...(nationalId ? { nationalId } : {}),
                ...(existingMemberId ? { existingMemberId } : {}) }),
        });
    }
    catch {
        throw new MemberImportReconciliationApiError('unavailable', 'No pudimos registrar la resolución.');
    }
    statusError(response);
    const body = await payload(response);
    if (!response.ok) {
        const message = typeof body === 'object' && body !== null && 'message' in body && typeof body.message === 'string'
            ? body.message : 'No se pudo confirmar la resolución.';
        throw new MemberImportReconciliationApiError('invalid', message);
    }
    if (!isMemberImportResolutionResponse(body))
        throw new MemberImportReconciliationApiError('invalid', 'La respuesta de confirmación no es válida.');
    return body;
}
